import { render } from "./RoleSelectModal.vue?vue&type=template&id=67a9d50a&scoped=true"
import script from "./RoleSelectModal.vue?vue&type=script&lang=js"
export * from "./RoleSelectModal.vue?vue&type=script&lang=js"

import "./RoleSelectModal.vue?vue&type=style&index=0&id=67a9d50a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a9d50a"]])

export default __exports__